import tweens from './tweens';
import media from './media';

const intObserver = new IntersectionObserver((entries) => {
  entries
    .filter((entry) => entry.isIntersecting && entry.target.classList.contains('is-detectable'))
    .forEach((entry) => {
      intObserver.unobserve(entry.target);
      entry.target.classList.remove('is-detectable');

      // do not float some items on mobile
      if (media.test('until-large') && entry.target.classList.contains('is-not-floating-mobile')) {
        return;
      }

      if (entry.target.classList.contains('text-words')) {
        tweens.tweenWords(entry.target);
      } else if (entry.target.classList.contains('is-floating')) {
        tweens.tweenFloat(entry.target);
      } else if (entry.target.classList.contains('is-rotatedimage')) {
        tweens.tweenRotatedImage(entry.target);
      } else {
        tweens.tweenIn(entry.target);
      }
    });
});

export default {
  init() {
    this.parse();
    document.addEventListener('detectable.parse', () => this.parse());
  },

  parse() {
    if (document.readyState == 'loading') {
      setTimeout(() => this.parse(), 50)
      return
    }
    const items = document.querySelectorAll('.is-detectable')
    Array
      .from(items)
      .forEach((el) => intObserver.observe(el));
  }
};
